/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { EmptyResponse } from '../models/empty-response';
import { esgTicketBatchDeleteForEsg } from '../fn/esg-ticket/esg-ticket-batch-delete-for-esg';
import { EsgTicketBatchDeleteForEsg$Params } from '../fn/esg-ticket/esg-ticket-batch-delete-for-esg';
import { esgTicketBatchUpsertForEsg$Json } from '../fn/esg-ticket/esg-ticket-batch-upsert-for-esg-json';
import { EsgTicketBatchUpsertForEsg$Json$Params } from '../fn/esg-ticket/esg-ticket-batch-upsert-for-esg-json';
import { esgTicketBatchUpsertForEsg$Plain } from '../fn/esg-ticket/esg-ticket-batch-upsert-for-esg-plain';
import { EsgTicketBatchUpsertForEsg$Plain$Params } from '../fn/esg-ticket/esg-ticket-batch-upsert-for-esg-plain';
import { esgTicketListForEsg } from '../fn/esg-ticket/esg-ticket-list-for-esg';
import { EsgTicketListForEsg$Params } from '../fn/esg-ticket/esg-ticket-list-for-esg';
import { esgTicketListForProfile } from '../fn/esg-ticket/esg-ticket-list-for-profile';
import { EsgTicketListForProfile$Params } from '../fn/esg-ticket/esg-ticket-list-for-profile';
import { esgTicketListForProfileAndForAssignedUser } from '../fn/esg-ticket/esg-ticket-list-for-profile-and-for-assigned-user';
import { EsgTicketListForProfileAndForAssignedUser$Params } from '../fn/esg-ticket/esg-ticket-list-for-profile-and-for-assigned-user';
import { esgTicketListForProfileAndForUser } from '../fn/esg-ticket/esg-ticket-list-for-profile-and-for-user';
import { EsgTicketListForProfileAndForUser$Params } from '../fn/esg-ticket/esg-ticket-list-for-profile-and-for-user';
import { EsgTickets } from '../models/esg-tickets';

@Injectable({ providedIn: 'root' })
export class EsgTicketService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `esgTicketListForProfile()` */
  static readonly EsgTicketListForProfilePath = '/esg/profile/{profileId}/esg/ticket';

  /**
   * TODO.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `esgTicketListForProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  esgTicketListForProfile$Response(params: EsgTicketListForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<EsgTickets>> {
    return esgTicketListForProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * TODO.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `esgTicketListForProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  esgTicketListForProfile(params: EsgTicketListForProfile$Params, context?: HttpContext): Observable<EsgTickets> {
    return this.esgTicketListForProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<EsgTickets>): EsgTickets => r.body)
    );
  }

  /** Path part for operation `esgTicketListForProfileAndForUser()` */
  static readonly EsgTicketListForProfileAndForUserPath = '/esg/profile/{profileId}/esg/ticket/for-user';

  /**
   * TODO.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `esgTicketListForProfileAndForUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  esgTicketListForProfileAndForUser$Response(params: EsgTicketListForProfileAndForUser$Params, context?: HttpContext): Observable<StrictHttpResponse<EsgTickets>> {
    return esgTicketListForProfileAndForUser(this.http, this.rootUrl, params, context);
  }

  /**
   * TODO.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `esgTicketListForProfileAndForUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  esgTicketListForProfileAndForUser(params: EsgTicketListForProfileAndForUser$Params, context?: HttpContext): Observable<EsgTickets> {
    return this.esgTicketListForProfileAndForUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<EsgTickets>): EsgTickets => r.body)
    );
  }

  /** Path part for operation `esgTicketListForProfileAndForAssignedUser()` */
  static readonly EsgTicketListForProfileAndForAssignedUserPath = '/esg/profile/{profileId}/esg/ticket/assigned-to-user';

  /**
   * TODO.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `esgTicketListForProfileAndForAssignedUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  esgTicketListForProfileAndForAssignedUser$Response(params: EsgTicketListForProfileAndForAssignedUser$Params, context?: HttpContext): Observable<StrictHttpResponse<EsgTickets>> {
    return esgTicketListForProfileAndForAssignedUser(this.http, this.rootUrl, params, context);
  }

  /**
   * TODO.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `esgTicketListForProfileAndForAssignedUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  esgTicketListForProfileAndForAssignedUser(params: EsgTicketListForProfileAndForAssignedUser$Params, context?: HttpContext): Observable<EsgTickets> {
    return this.esgTicketListForProfileAndForAssignedUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<EsgTickets>): EsgTickets => r.body)
    );
  }

  /** Path part for operation `esgTicketListForEsg()` */
  static readonly EsgTicketListForEsgPath = '/esg/profile/{profileId}/esg/{year}/{code}/ticket';

  /**
   * TODO.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `esgTicketListForEsg()` instead.
   *
   * This method doesn't expect any request body.
   */
  esgTicketListForEsg$Response(params: EsgTicketListForEsg$Params, context?: HttpContext): Observable<StrictHttpResponse<EsgTickets>> {
    return esgTicketListForEsg(this.http, this.rootUrl, params, context);
  }

  /**
   * TODO.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `esgTicketListForEsg$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  esgTicketListForEsg(params: EsgTicketListForEsg$Params, context?: HttpContext): Observable<EsgTickets> {
    return this.esgTicketListForEsg$Response(params, context).pipe(
      map((r: StrictHttpResponse<EsgTickets>): EsgTickets => r.body)
    );
  }

  /** Path part for operation `esgTicketBatchUpsertForEsg()` */
  static readonly EsgTicketBatchUpsertForEsgPath = '/esg/profile/{profileId}/esg/{year}/{code}/ticket';

  /**
   * TODO.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `esgTicketBatchUpsertForEsg$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  esgTicketBatchUpsertForEsg$Json$Response(params: EsgTicketBatchUpsertForEsg$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<EsgTickets>> {
    return esgTicketBatchUpsertForEsg$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * TODO.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `esgTicketBatchUpsertForEsg$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  esgTicketBatchUpsertForEsg$Json(params: EsgTicketBatchUpsertForEsg$Json$Params, context?: HttpContext): Observable<EsgTickets> {
    return this.esgTicketBatchUpsertForEsg$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<EsgTickets>): EsgTickets => r.body)
    );
  }

  /**
   * TODO.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `esgTicketBatchUpsertForEsg$Plain()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  esgTicketBatchUpsertForEsg$Plain$Response(params: EsgTicketBatchUpsertForEsg$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<EsgTickets>> {
    return esgTicketBatchUpsertForEsg$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * TODO.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `esgTicketBatchUpsertForEsg$Plain$Response()` instead.
   *
   * This method sends `text/plain` and handles request body of type `text/plain`.
   */
  esgTicketBatchUpsertForEsg$Plain(params: EsgTicketBatchUpsertForEsg$Plain$Params, context?: HttpContext): Observable<EsgTickets> {
    return this.esgTicketBatchUpsertForEsg$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<EsgTickets>): EsgTickets => r.body)
    );
  }

  /** Path part for operation `esgTicketBatchDeleteForEsg()` */
  static readonly EsgTicketBatchDeleteForEsgPath = '/esg/profile/{profileId}/esg/{year}/{code}/ticket';

  /**
   * TODO.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `esgTicketBatchDeleteForEsg()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  esgTicketBatchDeleteForEsg$Response(params: EsgTicketBatchDeleteForEsg$Params, context?: HttpContext): Observable<StrictHttpResponse<EmptyResponse>> {
    return esgTicketBatchDeleteForEsg(this.http, this.rootUrl, params, context);
  }

  /**
   * TODO.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `esgTicketBatchDeleteForEsg$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  esgTicketBatchDeleteForEsg(params: EsgTicketBatchDeleteForEsg$Params, context?: HttpContext): Observable<EmptyResponse> {
    return this.esgTicketBatchDeleteForEsg$Response(params, context).pipe(
      map((r: StrictHttpResponse<EmptyResponse>): EmptyResponse => r.body)
    );
  }

}
